/**
 * Satu-satunya tempat membaca import.meta.env.
 * Sisa aplikasi mengimpor `env` dari sini agar mudah diuji & di-mock.
 */
export const env = {
  /** Base URL REST API POS (Go BE), mis. http://localhost:8080/api/v1 */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  appTitle: import.meta.env.VITE_APP_TITLE ?? 'POS Dashboard',
  /** Tipe client untuk BE: 'web' (tanpa refresh token) atau 'mobile'. */
  clientType: (import.meta.env.VITE_CLIENT_TYPE ?? 'web') as 'web' | 'mobile',
  /**
   * Dashboard terhubung langsung ke REST API Go (/api/v1/dashboard/overview).
   * Set VITE_USE_MOCK_DASHBOARD=true jika ingin memakai mock data.
   */
  useMockDashboard: import.meta.env.VITE_USE_MOCK_DASHBOARD === 'true',
  /**
   * Tombol export produk.
   */
  featureProductExport: import.meta.env.VITE_FEATURE_PRODUCT_EXPORT !== 'false',
  /**
   * Modul layout meja aktif (terhubung ke BE /api/v1/table-layout).
   */
  featureTableLayout: import.meta.env.VITE_FEATURE_TABLE_LAYOUT !== 'false',
  /**
   * Layout meja memakai HTTP repository terhubung ke BE Go.
   * Set VITE_USE_MOCK_TABLES=true jika ingin memakai mock data.
   */
  useMockTables: import.meta.env.VITE_USE_MOCK_TABLES === 'true',
  /**
   * Pengaturan printer memakai HTTP repository terhubung ke BE Go (/api/v1/outlets/:outletId/printers).
   * Set VITE_USE_MOCK_PRINTERS=true jika ingin memakai mock data.
   */
  useMockPrinters: import.meta.env.VITE_USE_MOCK_PRINTERS === 'true',
} as const
